import { useRef, useEffect } from 'react';
import PropTypes from '@userzoomlibraries/toolkit-js-utils/prop-types';
import isString from '@userzoomlibraries/toolkit-js-utils/is-string';
import getFocusableElements from '@userzoomlibraries/toolkit-js-utils/get-focusable-elements';

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useFocusJail = function useFocusJail() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$focusOnMount = _ref.focusOnMount,
      focusOnMount = _ref$focusOnMount === void 0 ? false : _ref$focusOnMount,
      _ref$initialFocusElem = _ref.initialFocusElement,
      initialFocusElement = _ref$initialFocusElem === void 0 ? null : _ref$initialFocusElem,
      ref = _ref.ref;

  var focusJailRef = useRef(ref);
  useEffect(function () {
    var focusJailElement = focusJailRef.current;
    var allFocusableElements = getFocusableElements(focusJailElement);

    var _allFocusableElements = _slicedToArray(allFocusableElements, 1),
        firstFocusableElement = _allFocusableElements[0];

    if (focusOnMount) {
      if (initialFocusElement) {
        var elementToFocusOnInit = isString(initialFocusElement) ? document.getElementById(initialFocusElement) : initialFocusElement;
        elementToFocusOnInit.focus();
      } else if (firstFocusableElement) {
        firstFocusableElement.focus();
      }
    }

    var onTab = function onTab(event) {
      var isTabPressed = [event.key, event.code].includes('Tab') || event.keyCode === 9;

      if (isTabPressed) {
        var _document = document,
            activeElement = _document.activeElement;
        var allFocusableElementsAsArray = Array.from(allFocusableElements);
        var currentIndex = allFocusableElementsAsArray.findIndex(function (each) {
          return each.isSameNode(activeElement);
        });

        if (event.shiftKey) {
          currentIndex -= 1;
        } else {
          currentIndex += 1;
        }

        if (currentIndex < 0) {
          currentIndex = allFocusableElementsAsArray.length - 1;
        } else if (currentIndex > allFocusableElementsAsArray.length - 1) {
          currentIndex = 0;
        }

        var elementToFocus = allFocusableElementsAsArray[currentIndex];

        if (focusJailElement.contains(elementToFocus)) {
          elementToFocus.focus();
          event.preventDefault();
        } else {
          firstFocusableElement.focus();
          event.preventDefault();
        }
      }
    };

    if (focusJailElement) {
      focusJailElement.addEventListener('keydown', onTab, true);
    }

    return function () {
      if (focusJailElement) {
        focusJailElement.removeEventListener('keydown', onTab, true);
      }
    };
  }, [ref, focusOnMount, initialFocusElement]);
  return focusJailRef;
};

useFocusJail.HOOK_ID = 'Gearz.ReactHooks.useFocusJail';
useFocusJail.returnType = PropTypes.shapeWithDescription({
  current: PropTypes.instanceOf(Element)
}, 'Reference of the focus jailed element.');
useFocusJail.parameterTypes = {
  parameter: PropTypes.shapeWithDescription({
    initialFocusElement: PropTypes.oneOfTypeWithDescription([PropTypes.string, PropTypes.instanceOf(HTMLElement)], 'Element to focus on mount.'),
    focusOnMount: PropTypes.boolWithDescription('Flag to focus the initialFocusElement on mount.'),
    ref: PropTypes.shapeWithDescription({
      current: PropTypes.instanceOf(Element)
    }, 'Custom reference.')
  }, 'Settings of focus jail.')
};
useFocusJail.defaultParameters = {
  parameter: {
    focusOnMount: false,
    initialFocusElement: null,
    ref: null
  }
};

export { useFocusJail as default };
